import * as React from 'react';
import { NotFoundPage } from '../../../NotFoundPage/NotFoundPage';
import { Redirect } from 'react-router';
import { UserRole } from '../../../../types/UserRole';
import LoginServices from '../../../../services/LoginServices';

interface Props {
    allowedUsers: UserRole[];
    children: JSX.Element;
}

interface State {
}

export class ProtectedPage extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
    }

    render(): JSX.Element {
        const allowed: boolean = this.props.allowedUsers.some(
            (element: UserRole) => {
                return (LoginServices.getInstance().getType() === element.toString());
            }
        );
        if (allowed) {
            return (this.props.children);
        } else if (LoginServices.getInstance().getType() === UserRole.NOT_LOGED_IN.toString()) {
            return (<Redirect to="/" />);
        } else {
            return (<NotFoundPage />);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Page/ProtectedPage/ProtectedPage.tsx